// SEO landing pages — data lives in seo-pages.json (also consumed by scripts/prerender.js).
import SEO_PAGES_DATA from "./seo-pages.json";

export const SEO_PAGES = SEO_PAGES_DATA;

// Human-friendly label used in breadcrumbs and related links
export const PAGE_LABELS = Object.fromEntries(
  Object.entries(SEO_PAGES).map(([slug, p]) => [slug, p.breadcrumbLabel || p.h1.replace(" in Hyderabad", "")])
);
